import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ChevronRight } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { homepageSlice } from '../../../common/reducers/homepage';
import { IMetaUpdateDealerOfferParams } from '../../../common/reducers/types';
import { selectReportABugFlowStarted } from '../../../common/selectors/homepage';
import { store } from '../../../common/store';
import { ACTIONS } from '../../../constants';
import { appRoutes } from '../../../react-router';
import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import s from '../styles.scss';
import { SectionComponentProps } from '../types';
import { chatWithUsDataHooks } from './ChatWithUs.dataHooks';
import { ChatWithUsIconSvg } from './ChatWithUsIconSvg';

export const ChatWithUs: FC<SectionComponentProps> = ({ positionIndex }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const reportABugFlowStarted = useSelector(selectReportABugFlowStarted);

  const navigateToChatbot = useCallback(() => {
    biHelpCenter.logChatWithUsInteraction(positionIndex);

    if (reportABugFlowStarted) {
      store.dispatch<IMetaUpdateDealerOfferParams>({
        type: ACTIONS.META_UPDATE_DEALER_OFFER_PARAMS,
        // triggering restart session by changing nodeId which was defined for report-a-bug flow case
        dealerOfferParams: new Map([['nodeId', '']]),
      });
      store.dispatch(homepageSlice.actions.reportABugFlowStarted(false));
    }

    navigate(appRoutes.chatbot());
  }, [navigate, positionIndex]);

  return (
    <div
      onClick={navigateToChatbot}
      data-hook={chatWithUsDataHooks.container()}
    >
      <Box
        className={s.homepageActionItem}
        verticalAlign="middle"
        gap={3}
        padding="18px 6px 18px 18px"
        cursor="pointer"
      >
        <ChatWithUsIconSvg />
        <Box direction="vertical">
          <Text size="small" secondary>
            {t<TLocalesKeys>('home_chat_with_us_content')}
          </Text>
        </Box>
        <ChevronRight className={s.svgIcon} size="24" />
      </Box>
    </div>
  );
};
